import Skeleton from '@zenbusiness/zui/Skeleton';

import * as Styled from './WebinarCard.styles';

function WebinarCardSkeleton() {
  return (
    <Styled.CardWrapper>
      <Skeleton variant="rectangular" width="100%" height="10rem" />
      <Styled.ContentWrapper>
        <div>
          <Skeleton width="80%" height="1.5rem" sx={{ mb: 1 }} />
          <Skeleton width="100%" height="1rem" sx={{ mb: 0.5 }} />
          <Skeleton width="70%" height="1rem" />
        </div>
        <Skeleton width="25%" height="2.5rem" sx={{ mt: 2 }} />
      </Styled.ContentWrapper>
    </Styled.CardWrapper>
  );
}

export default WebinarCardSkeleton;
